class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.variantInput = this.querySelector('[data-variant-input]');
    this.submit = this.querySelector('[data-add-to-cart]');
    this.submitText = this.querySelector('[data-add-to-cart-text]');
    this.quantityInput = this.querySelector('[data-quantity-input]');
    this.dec = this.querySelector('[data-quantity-decrement]');
    this.inc = this.querySelector('[data-quantity-increment]');

    this.addEventListener('submit', (e) => this.onSubmit(e));
    this.dec?.addEventListener('click', () => this.changeQuantity(-1));
    this.inc?.addEventListener('click', () => this.changeQuantity(1));

    document.addEventListener('variant:change', (e) => this.onVariantChange(e.detail));
  }

  changeQuantity(delta) {
    if (!this.quantityInput) return;
    const next = Math.max(1, parseInt(this.quantityInput.value, 10) + delta);
    this.quantityInput.value = next;
  }

  onVariantChange(detail) {
    if (!detail) return;
    if (this.variantInput) this.variantInput.value = detail.id;
    if (this.submit && this.submitText) {
      if (detail.available) {
        this.submit.disabled = false;
        var label = this.submit.dataset.labelAdd || this.submitText.textContent;
        if (this.submit.dataset.showPrice === 'true' && detail.price) {
          label += ' · ' + detail.price;
        }
        this.submitText.textContent = label;
      } else {
        this.submit.disabled = true;
        this.submitText.textContent = this.submit.dataset.labelSoldOut || 'sold out';
      }
    }
    this.updatePrice(detail);
  }

  updatePrice(detail) {
    const current = document.querySelector('[data-product-price-current]');
    if (current && detail.price) {
      current.textContent = detail.price;
      current.classList.remove('hidden');
    }

    // Progressive product forms start on a "from" price since nothing is
    // selected yet; once a full variant is chosen, replace it with the real one.
    const fromPrice = document.querySelector('[data-product-price-from]');
    if (fromPrice) fromPrice.classList.add('hidden');

    const compare = document.querySelector('[data-product-price-compare]');
    if (compare) {
      if (detail.comparePrice) {
        compare.textContent = detail.comparePrice;
        compare.hidden = false;
        compare.classList.remove('hidden');
      } else {
        compare.hidden = true;
        compare.classList.add('hidden');
      }
    }
  }

  async onSubmit(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (!form) return;
    this.submit?.setAttribute('disabled', 'true');
    try {
      const formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      // A hidden id keeps every kit with add-ons its own line, so the same photo added
      // twice still gets a fresh key to nest under (see addKitCopy in cart-drawer.js).
      if (form.dataset.extraVariants) formData.append('properties[_kit]', String(Date.now()));
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(await response.text());
      const data = await response.json();
      // The stepper's optional add-ons are their own products, added right after the kit
      // and nested under its line, so cart, checkout and the order show which kit they
      // belong to (two kits with different photos are separate lines with their own keys).
      if (form.dataset.extraVariants) {
        const parent_line_key = data.key ?? data.items?.[0]?.key;
        const items = form.dataset.extraVariants.split(',').map((id) => ({ id: Number(id), quantity: 1, parent_line_key }));
        const extra = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!extra.ok) throw new Error(await extra.text());
      }
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
    } catch (err) {
      console.error('Add to cart failed', err);
      document.dispatchEvent(new CustomEvent('cart:error', { detail: err.message }));
    } finally {
      this.submit?.removeAttribute('disabled');
    }
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}
